var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "result-form-box-list" },
    _vm._l(_vm.analysisList, function(item) {
      return _c("div", { staticStyle: { "flex-grow": "1" } }, [
        _c(
          "div",
          { staticStyle: { display: "block", position: "relative" } },
          [
            _c("div", { staticClass: "form-title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.PONumber")))
            ]),
            _c("el-input", {
              attrs: { disabled: true },
              model: {
                value: item.poNo,
                callback: function($$v) {
                  _vm.$set(item, "poNo", $$v)
                },
                expression: "item.poNo"
              }
            }),
            _c("div", { staticClass: "form-title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.MaterialInformation")))
            ]),
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: item.goodsDetails,
                      height: "100%",
                      border: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.MaterialNumber"),
                        width: "120"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.materialCode))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.HsCode2"),
                        width: "120"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.hsCode))])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.itemCount"),
                        width: "80"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.quantity))])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.NetWeightKg"),
                        width: "80"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.netWeight))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                        width: "200"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.chineseDescription))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishCommodityName"),
                        width: "200"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.englishDescription))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("SeaExport.Package"),
                        width: "80"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.packing))])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }